import React from "react";
import { ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";

export default function Nav() {
  const { count, setDrawerOpen, ct } = useCart();
  return (
    <header
      data-testid="main-nav"
      className="sticky top-0 z-50 border-b border-neutral-800/80 bg-neutral-950/90 backdrop-blur-md"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand" className="flex items-center gap-3">
          <div className="w-3.5 h-3.5 bg-white rounded shadow-[0_0_12px_rgba(255,255,255,0.6)]" />
          <span className="text-sm font-bold tracking-wider uppercase text-neutral-100">{ct("brand.name", "Gridline Machined Plates")}</span>
        </a>
        <nav className="hidden md:flex items-center gap-8 text-xs uppercase tracking-widest text-neutral-400">
          <a data-testid="nav-catalog" href="#inventory" className="hover:text-white transition-colors">Parts Catalog</a>
          <a data-testid="nav-specs" href="#materials" className="hover:text-white transition-colors">Specs & Fit</a>
          <a data-testid="nav-custom" href="#contact" className="hover:text-white transition-colors">Custom Order</a>
          <a data-testid="nav-reviews" href="#reviews" className="hover:text-white transition-colors">Rider Proof</a>
          <a data-testid="nav-faq" href="#faq" className="hover:text-white transition-colors">FAQ</a>
        </nav>
        <button
          data-testid="nav-cart-button"
          onClick={() => setDrawerOpen(true)}
          className="flex items-center gap-2 text-xs uppercase tracking-wider font-bold bg-white hover:bg-neutral-200 text-neutral-950 px-4 py-2 rounded transition-colors"
        >
          <ShoppingCart className="w-4 h-4" />
          Cart (<span data-testid="nav-cart-count">{count}</span>)
        </button>
      </div>
    </header>
  );
}
